import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, switchMap, of, catchError, map, throwError } from 'rxjs';
import { BaseRestApiService } from 'src/app/service/baseRestApiService.service';
import { EndPoints, UrlProviderService } from 'src/app/service/urlprovider.service';

@Injectable({
    providedIn: 'root'
})
export class GraduationReportService extends BaseRestApiService {
    constructor(http: HttpClient, urlProvider: UrlProviderService) {
        super(http, urlProvider);
    }

    search(chosenRegions: number[], chosenCounties: number[], chosenSchoolDistricts: number[], chosenSchools: number[], schoolYear: string): Observable<any> {
        return this.post<any>(EndPoints.graduationReport_search, false, '', {
            chosenRegions: chosenRegions,
            chosenCounties: chosenCounties,
            chosenSchoolDistricts: chosenSchoolDistricts,
            chosenSchools: chosenSchools,
            schoolYear: schoolYear
        }).pipe(
            switchMap((result) => {
                const properties = Object.keys(result);
                properties.forEach((property) => {
                    if (['regions', 'counties', 'schoolDistricts', 'schools'].indexOf(property) >= 0) {
                        result[property] = JSON.parse(result[property]);
                    }
                });

                return of(result);
            }),
            catchError((err) => {
                console.log(err);
                return throwError(() => new Error(err));
            })
        );
    }
}
